// extracted by mini-css-extract-plugin
export default {"Categories":"Categories_Categories__8RBzJ","active":"Categories_active__ldV7L"};